import { React, useState, useRef, useEffect } from "react";
import { isMobile } from "react-device-detect";
const CricketScoreBoard = ({ eventDetails, scoreboardData }) => {
  //console.log("scoreboardData->", scoreboardData);

  const [currentBall, setCurrentBall] = useState("");
  const [team1Name, setTeam1Name] = useState("");
  const [team2Name, setTeam2Name] = useState("");
  const [lastSixBalls, setLastSixBalls] = useState("");
  const [target, setTarget] = useState("");
  const [team1RunRate, setTeam1RunRate] = useState("");
  const [team2RunRate, setTeam2RunRate] = useState("");

  const [team1Score, setTeam1Score] = useState("");
  const [team1Wicket, setTeam1Wicket] = useState("");
  const [team1Over, setTeam1Over] = useState("");

  const [team2Score, setTeam2Score] = useState("");
  const [team2Wicket, setTeam2Wicket] = useState("");

  const [team2Over, setTeam2Over] = useState("");
  const [requiredRunRate, setRequiredRunRate] = useState("");
  const [toWin, setToWin] = useState("");

  const [Team1Display, setTeam1Display] = useState(false);
  const [Team2Display, setTeam2Display] = useState(false);

  const [volumeStatus, setVolumeStatus] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [audioSrc, setAudioSrc] = useState("");
  const playedAudios = useRef(new Set());
  const audioRef = useRef(null);

  const setScoreBoard = async (scoreboardData) => {
    setCurrentBall(scoreboardData?.commentry);
    let sourceUrl = "";
    if (currentBall == "No Run") {
      sourceUrl = "/assets/audio/norun.mp3";
    } else if (currentBall == "Ball Chaloo!!") {
      sourceUrl = "/assets/audio/ballrunning.mp3";
    } else if (currentBall == "Over") {
      sourceUrl = "/assets/audio/over.mp3";
    } else if (currentBall == "Six") {
      sourceUrl = "/assets/audio/New6Run.mp3";
    } else if (currentBall == "Single") {
      sourceUrl = "/assets/audio/1run.mp3";
    } else if (currentBall == "1 Runs") {
      sourceUrl = "/assets/audio/1run.mp3";
    } else if (currentBall == "2" || currentBall == "Double") {
      sourceUrl = "/assets/audio/2run.mp3";
    } else if (currentBall == "3 Runs" || currentBall == "3") {
      sourceUrl = "/assets/audio/3run.mp3";
    } else if (currentBall == "4 Runs" || currentBall == "Four") {
      sourceUrl = "/assets/audio/4run.mp3";
    } else if (currentBall == "Wide + Four") {
      sourceUrl = "/assets/audio/3run.mp3";
    } else if (currentBall == "Faster") {
      sourceUrl = "/assets/audio/faster.mp3";
    } else if (currentBall == "Spinner") {
      sourceUrl = "/assets/audio/Spinner.mp3";
    } else if (currentBall == "Review") {
      sourceUrl = "/assets/audio/Review.mp3";
    } else if (currentBall == "Wicket" || currentBall == "Out") {
      sourceUrl = "/assets/audio/wicket.mp3";
      //commentry = "Out";
    } else if (currentBall == "Wide Ball") {
      sourceUrl = "/assets/audio/wide.mp3";
    } else if (currentBall == "Bowling Team Review") {
      sourceUrl = "/assets/audio/Review.mp3";
    } else if (currentBall == "Wide + 4") {
      sourceUrl = "/assets/audio/4_Wide.mp3";
    } else if (currentBall == "No Ball") {
      sourceUrl = "/assets/audio/noball.mp3";
    }

    if (sourceUrl != "") {
      setAudioSrc(sourceUrl);
    }
    setTeam1Name(scoreboardData?.team1Name);
    setTeam2Name(scoreboardData?.team2Name);
    setLastSixBalls(scoreboardData?.lastSixBalls);
    setTarget(scoreboardData?.target);
    setTeam1RunRate(scoreboardData?.team1RunRate);
    setTeam2RunRate(scoreboardData?.team2RunRate);

    setTeam1Score(scoreboardData?.team1Score);
    setTeam1Wicket(scoreboardData?.team1Wicket);
    setTeam1Over(scoreboardData?.team1Over);

    setTeam2Score(scoreboardData?.team2Score);
    setTeam2Wicket(scoreboardData?.team2Wicket);
    setTeam2Over(scoreboardData?.team2Over);
    setRequiredRunRate(scoreboardData?.requiredRunRate);
    setToWin(scoreboardData?.toWin);

    if (scoreboardData?.target === 0 || scoreboardData?.toWin === "") {
      setTeam1Display(true);
      setTeam2Display(false);
    } else {
      setTeam1Display(false);
      setTeam2Display(true);
    }
  };

  const volumOnOff = (status) => {
    setEnabled(true);
    setVolumeStatus(status);
  };

  useEffect(() => {
    if (audioSrc && !playedAudios.current.has(audioSrc)) {
      if (enabled && audioSrc) {
        audioRef.current.src = audioSrc;
        audioRef.current.play();
        playedAudios.current.add(audioSrc);
      }
    }
  }, [audioSrc, enabled]);

  useEffect(() => {
    setScoreBoard(scoreboardData);
  }, [scoreboardData]); // Empty dependency array

  return (
    <div>
      <div
        className="table-box-header"
        style={{ paddingBottom: "2px", marginTop: "2px" }}
      >
        <div className="row no-gutters">
          <div className="col-md">
            <div className="tb-top-text">
              <p></p>

              <div style={{ display: Team1Display ? "" : "none" }}>
                <span style={{ color: "white" }}>{team1Name}</span>
                <span
                  className="medium-black"
                  style={{
                    fontWeight: "bold",
                    color: "white"
                  }}
                >
                  {team1Score}/{team1Wicket} ({team1Over})
                </span>

                <span
                  className="runrate"
                  style={{ color: "white", paddingLeft: "10px" }}
                >
                  CRR:&nbsp; {team1RunRate}
                </span>

                <p className="runrate" style={{ color: "white" }}>
                  This Over: {lastSixBalls}
                </p>
              </div>

              <div style={{ display: Team2Display ? "" : "none" }}>
                <span style={{ color: "white" }}>{team2Name}</span>
                <span
                  className="medium-black"
                  style={{
                    fontWeight: "bold",
                    color: "white",
                    paddingLeft: "10px"
                  }}
                >
                  <b>
                    {team2Score}/ {team2Wicket} ({team2Over})
                  </b>
                </span>

                <span
                  className="runrate"
                  style={{ color: "white", paddingLeft: "20px" }}
                >
                  {" "}
                  CRR:&nbsp; {team2RunRate}{" "}
                </span>
                <span
                  className="runrate"
                  style={{ color: "white", paddingLeft: "20px" }}
                >
                  Target: &nbsp;
                  <span style={{ fontWeight: "bold" }}> {target}</span>
                </span>
                <p className="runrate" style={{ color: "white" }}>
                  This Over: {lastSixBalls}
                </p>
                <p className="runrate" style={{ color: "white" }}>
                  {toWin}{" "}
                  <span style={{ paddingLeft: "20px", fontSize: "14px" }}>
                    RRR{requiredRunRate}
                  </span>
                </p>
              </div>

              <span
                className="green-upper-text"
                style={{ marginTop: isMobile ? "-7px" : "-30px" }}
              >
                <div className="row">
                  <div>{currentBall}</div>
                  <div style={{ marginLeft: "8px", marginTop: "-3px" }}>
                    <i
                      onClick={() => volumOnOff(false)}
                      className="fa fa-volume-up"
                      style={{
                        display: volumeStatus ? "" : "none",
                        fontSize: "17px",
                        color: "white",
                        marginRight: "16px"
                      }}
                      aria-hidden="true"
                    ></i>

                    <i
                      className="fas fa-volume-mute fa-inverse"
                      onClick={() => volumOnOff(true)}
                      style={{
                        fontSize: "17px",
                        color: "white",
                        marginRight: "16px",
                        display: volumeStatus ? "none" : ""
                      }}
                      aria-hidden="true"
                    ></i>
                    <audio ref={audioRef} src="" />
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CricketScoreBoard;

{
  /*
var lastSixBalls = '';
var thisOverRun = '';
let targetVal = '';

if (fancyBoard != null && fancyBoard != "" && fancyBoard != undefined) {

    if (fancyBoard.target == 0 || fancyBoard.team2Name == '') {

        //team1 Batting 
        var html = "";
        html += '<span style="color:white">' + fancyBoard.team1Name; + '</span>';
        html += '<span className="medium-black" style="font-weight:bold;color:white"> ' + fancyBoard.team1Score + '/' + fancyBoard.team1Wicket + ' (' + fancyBoard.team1Over + ')</span>';
        html += '<span className="runrate" style="color:white"> CRR: ' + fancyBoard.team1RunRate + '</span>';

        var thisOver = '';
        if (fancyBoard.lastSixBalls != '') {
            thisOver += 'This Over : &nbsp;' + fancyBoard.lastSixBalls;
        }
        $("#this_over_span").html(thisOver);

        $("#team1_batting").html(html);
        $("#team1_batting").show();
        $("#team2_batting").hide();
    } else {
        //team2 Batting 
        var html = "";
        html += '<span style="color:white">' + fancyBoard.team2Name; + '</span>';
        html += '<span className="medium-black" style="font-weight:bold;color:white"> ' + fancyBoard.team2Score + '/' + fancyBoard.team2Wicket + ' (' + fancyBoard.team2Over + ')</span>';
        html += '<span className="runrate" style="color:white"> CRR: ' + fancyBoard.team2RunRate + '</span>';
        html += '<span className="runrate" style="color:white">Target: ' + fancyBoard.target + '</span>';

        var thisOver = '';
        if (fancyBoard.lastSixBalls != '') {
            thisOver += 'This Over : &nbsp;' + fancyBoard.lastSixBalls;
        }
        $("#this_over_span").html(thisOver);

        var requiredTxt = '';
        if (fancyBoard.toWin != '') {
            requiredTxt += fancyBoard.toWin + "&nbsp;&nbsp;&nbsp;&nbsp;RRR: " + fancyBoard.requiredRunRate;
        }
        $("#run_traget_span").html(requiredTxt);

        $("#team1_batting").html(html);
        $("#team1_batting").show();
        $("#team2_batting").hide();
    }
}
*/
}
